import { Container, Paper, Space, Group, Button, Text } from "@mantine/core";
import React from "react";
import Header from "../components/Header";
import { RegistryGrid } from "../components/RegistryGrid";
import Starfield from "../components/StarField";

interface IGiftsProps {
  onSignGuestbook: () => void;
}
export const Gifts = ({ onSignGuestbook }: IGiftsProps) => {
  return (
    <>
      <Paper withBorder shadow="xs" p={"xl"}>
        <Text size="lg" fw={500} ta={"center"}>
          We're so excited to celebrate the upcoming arrival of our baby with all of you. Your presence, generosity, and well-wishes will make this journey even more memorable, and we can't wait to share the joy with our closest family and friends!
        </Text>
      </Paper>
      <RegistryGrid />
      <Paper withBorder shadow="xs" p={"xl"}>
        <Text size="lg" fw={500} ta={"center"}>
          Thank you for being part of this special moment in our lives. Your love and support mean the world to us!
        </Text>
      </Paper>
      <Space h={"xl"} />
      <Group justify='center'>
        <Button bg={"#7fac9d"} onClick={onSignGuestbook}>Sign Our Guestbook</Button>
      </Group>
    </>
  );
};
